<template>
<div class="chat-page">
  <el-container  class="chat-wrapper">
    <el-aside width="240px" class="left-aside">
      <MessageBox :type="activeKey" :select="select" ref="messageBox" />
    </el-aside>
    <el-container>
      <Message
        :type="activeKey"
        :broken="broken"
        :hideUserList="hideUserList"
        :showUserList="showUserList"
        :selectMess="selectMess"
        ref="messageList"
      />
    </el-container>
  </el-container>
  <!-- 添加好友 -->
  <AddFriend ref="addFriendMethods" />
  <!-- 好友申请  好友黑名单 加入群组
  <GetFriendRequest />
  <FirendBlack ref="firendModel" />
  <AddGroupUser ref="addGroupModel" /> -->
  <!-- 创建群组 -->
  <!-- <CreateGroup ref="createGroupModel" />   -->
  <!-- <VidoeSetting ref="videoSetting" /> -->
  <!-- <GroupRequest /> -->
  <!-- <GroupInvite /> -->
</div>
</template>

<script>
import MessageBox from "./children/chat/index.vue";
import Message from "./children/chat/message.vue";
import AddFriend from "./children/addModal/addFriend.vue";
// import GetFriendRequest from "./children/addModal/getFriendRequest.vue";
// import FirendBlack from "./children/addModal/firendBlack.vue";
// import AddGroupUser from "./children/group/addGroupUser.vue";
// import CreateGroup from "./children/group/createGroup.vue";
// import VidoeSetting from "./children/videoSetting/index";
// import GroupRequest from "./children/group/groupRequest.vue";
// import GroupInvite from "./children/group/groupInvite.vue";
import { mapState, mapActions } from "vuex";
import {GetAccountType,GetUserSingleChats} from '@/scripts/api.js'
export default {
  data() {
    return {
      groupRead: false,
      contactRead: false,
      showSettingOptions: false,
      activeKey: this.$query('activeKey') || 'group',
      selectedItem: "",
      showAddOptions: false,
      addList: [
        {
          name: "添加好友",
          id: "1",
          icon: "chat"
        },
        {
          name: "申请入群",
          id: "2",
          icon: "friends"
        },
        {
          name: "创建群组",
          id: "3",
          icon: "comment"
        }
      ],
      collapsed: false,
      broken: false,
      current: ["group"],
      groupId:'',
      userCode:'',
      selectMess: {}
    };
  },
  computed: {
    chatList() {
      return this.$store.state.chat.msgList;
    },
    hxIsLogin(){
      return this.$store.state.hxIsLogin;
    },
    ...mapState({
      chatId:state=>state.chatId,
      hxIsLogin:state=>state.hxIsLogin,
      userInfo:state=>state.userInfo,
    })
  },
  watch: {
    hxIsLogin(value){
      if(value){
        let that=this;
        this.onGetGroupinfo({select_groupid: this.chatId});
        if (this.activeKey === "contact") {
          this.onGetContactUserList();
        } else if (this.activeKey === "group") {
          this.onGetGroupUserList();
        } else if (this.activeKey === "chatroom") {
          this.onGetChatroomUserList();
        }
      }
    },
    chatId(value,old){
      console.log("chatId value,old",value,old,"this.activeKey",this.activeKey);      
      if(value!=old && this.activeKey=='group'){
        this.onGetGroupinfo({
          select_groupid: this.chatId
        })
      }
    },
  },
  created() {
    this.groupId= '';
    this.userCode= '';
    this.$store.commit('setChatType', 'group');
    if(this.groupId){
      this.$store.commit('setChatId', this.groupId);
    }
    this.pageInit();
  },
  mounted() {
    if(this.hxIsLogin){
      this.getUnread('group');
      this.onGetGroupinfo({select_groupid:this.chatId});
    }
    this.chatTypeChange(this.activeKey)
    
  },
  methods: {
    ...mapActions([
      "onLogout", 
      "onGetFirendBlack",
      'onLogin',
      "onGetContactUserList",
      "onGetGroupUserList",
      "onGetChatroomUserList",
      'onGetGroupinfo']),
    pageInit(){
      if(this.$query('chatType')) {
        this.randomPageInit();
        return;
      }
      let params={
        platform:'pcweb'
      };
      let userCode=this.userInfo && this.userInfo.UserCode?this.userInfo.UserCode:this.userCode;
      if (this.userInfo.LoginAccountType == 1) {
          params['userId']=userCode.substr(1);
      }
      if (this.userInfo.LoginAccountType == 2) {
          params['companyId']=userCode.substr(1);
      }
      //获取环信登录名和密码
      GetAccountType(params).then(r=>{
        if(r.Result==1){
          this.onLogin({
            username: r.Data.ImUserId,
            password: r.Data.ImUserPassWord
          });
        }
      })
      GetUserSingleChats({
        PageSize:999,
        PageNo:1,
        UserCode:userCode,
        platform:'pcweb'
      }).then(r=>{
       if(r.Result==1){
          let arr=[];
          // arr=arr.concat(r.Data.Lines);
          let  contactId = localStorage.getItem('hxLoginId')
          if(contactId){  
            arr=arr.concat(r.Data.FriendsLines);
          }
          console.log("contactId 00000 ",contactId);
          this.$store.commit('setSingleChatList',arr);
        }
      })
    },
    // 若是游客的话
    randomPageInit(){
      //获取环信登录名和密码
      this.onLogin({
        username: localStorage.getItem('hxLoginId'),
        password: "supai2020"
      });
      GetUserSingleChats({
        PageSize:999,
        PageNo:1,
        UserCode: localStorage.getItem('hxLoginId'),
        platform:'pcweb'
      }).then(r=>{
       if(r.Result==1){
          let arr=[];
          // arr=arr.concat(r.Data.Lines);
          let  contactId = localStorage.getItem('hxLoginId')
          if(contactId){  
            arr=arr.concat(r.Data.FriendsLines);
          }
          console.log("contactId 00000 ",contactId);
          this.$store.commit('setSingleChatList',arr);
        }
      })
    },
    toLogout() {
      this.onLogout();
    },
    onCollapse(collapsed, type) {
      if (type != "responsive") {
        this.$data.collapsed = true;
      } else {
        this.$data.collapsed = false;
      }
    },
    onBreakpoint(broken) {
      this.$data.broken = broken;
    },
    hideUserList() {
      this.$data.collapsed = true;
    },
    showUserList() {
      this.$data.collapsed = false;
    },
    select(i) {
      console.log("点击了某个用户之后",i);
      this.$refs.messageList.select(i);
      this.selectMess = i;
      if (this.broken) {
        this.$data.collapsed = true;
      }
    },
    GetFirendBlack() {
      this.onGetFirendBlack();
      this.$refs.firendModel.changModel();
    },
    optionsVisibleChange() {
      this.$data.showSettingOptions = !this.$data.showSettingOptions;
    },
    chatTypeChange(type) {
      this.$data.activeKey = type;
      this.$store.commit('setChatType',type);
      // if (this.broken && this.collapsed) {
      //   this.$data.collapsed = false;
      // }
      switch (type) {
        case "contact":
          this.$refs.messageBox.onGetContactUserList();
          break;
        case "group":
          this.$refs.messageBox.onGetGroupUserList();
          break;
        case "chatroom":
          this.$refs.messageBox.onGetChatroomUserList();
          break;
        default:
          break;
      }
      this.$refs.messageList.getCurrentMsg(type);
    },
    addModalChange() {
      this.$data.showAddOptions = !this.$data.showAddOptions;
    },
    ulClick(i) {
      // this.addModalChange();
      switch (i) {
        case "1":
          this.$refs.addFriendMethods.changeModal();
          break;
        case "2":
          this.$refs.addGroupModel.changeGroupModel();
          break;
        case "3":
          this.$refs.createGroupModel.changeCreateModel();
          break;
        default:
          break;
      }
    },
    // recEmedia() {
    //   this.$refs.videoSetting.show();
    // },
    getUnread(type) {
      const chatList = this.chatList[type];
      let obj = {
        contact: false,
        group: false
      };
      if (JSON.stringify(chatList) != "{}") {
        for (const item in chatList) {
          chatList[item].map((v, k) => {
            if (v.status === "unread") {
              if (v.chatType === "group") {
                obj.group = true;
              }
              if (v.chatType === "contact") {
                obj.contact = true;
              }
            }
            return obj;
          });
        }
      }
      return {
        contact: obj.contact,
        group: obj.group
      };
    }
  },
  components: {
    MessageBox,
    Message,
    AddFriend,
    // GetFriendRequest,
    // FirendBlack,
    // AddGroupUser,
    // CreateGroup,
    // VidoeSetting,
    // GroupRequest,
    // GroupInvite
  }
};
</script>
<style lang="scss" scoped>
@import '@/style/reset.scss';
body{
  background-color: rgba(0,0,0,0.6) !important;
}
.left-aside{
  background-color: #fff;
}
.chat-wrapper{
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  height: 800px;
  overflow: auto;
}
</style>
